<template>
  <div class="signup-container">
    <v-card
      width="550"
      style="border-radius: 14px"
      variant="outlined"
      :style="{
        borderBottom: '5px solid #272727',
        borderLeft: '2px solid #272727',
        borderTop: '2px solid #272727',
        borderRight: '5px solid #272727',
      }"
      class="bg-white"
    >
      <div class="logo bg-accent py-4" style="border-bottom: 1px solid #272727">
        <v-img
          width="40"
          :src="require('@/assets/logo/logo_dark.svg')"
          contain
        ></v-img>
        <!-- <b style="font-size: 18px">Stix</b> -->
      </div>

      <div class="sub-container signin" style="padding: 50px 50px">
        <h1
          style="margin-bottom: 20px; font-weight: 600; line-height: 1.3"
          :style="{
            fontSize: $vuetify.display.smAndDown ? '35px' : '40px',
          }"
          v-if="!$route.query.ws"
        >
          Your path to
          <span class="text-accent">consistent</span>
          growth.
        </h1>
        <h1
          style="margin-bottom: 10px"
          :style="{
            fontSize: $vuetify.display.smAndDown ? '35px' : '40px',
          }"
          v-else
        >
          Join the
          <span class="text-accent">{{ $route.query.name }}</span> workspace
        </h1>
        <p style="font-size: 13px; font-weight: 400">
          By accessing Stix, I agree with stix'
          <u
            class="text-accent"
            style="cursor: pointer"
            @click="
              openTab('https://www.stix.social/utilities/terms-of-service')
            "
            >Terms</u
          >
          and
          <u
            style="cursor: pointer"
            class="text-accent"
            @click="openTab('https://www.stix.social/utilities/privacy-policy')"
            >Privacy policy</u
          >.
        </p>
        <div class="login-buttons">
          <v-btn
            v-if="!useEmail"
            @click="google"
            elevation="0"
            height="50"
            outlined
            block
            :style="{
              borderBottom: '3px solid #272727',
              borderLeft: '1px solid #272727',
              borderTop: '1px solid #272727',
              borderRight: '3px solid #272727',
            }"
          >
            <v-img
              :src="require('@/assets/google-icon.png')"
              contain
              width="30px"
              class="mr-3"
            ></v-img>
            Access with Google
          </v-btn>

          <p
            @click="
              useEmail = !useEmail;
              mode = null;
            "
            v-if="!useEmail"
            class="mb-0"
            style="font-size: 12px; cursor: pointer"
          >
            <v-icon size="x-small">mdi-chevron-right</v-icon
            ><u>Access with email</u>
          </p>

          <div class="email" v-if="useEmail">
            <p
              @click="
                useEmail = false;
                mode = null;
              "
              class="mb-0"
              style="font-size: 12px; cursor: pointer"
            >
              <v-icon size="x-small">mdi-chevron-left</v-icon
              ><u>Access with Google</u>
            </p>
            <v-text-field
              placeholder="Enter your email to continue.."
              flat
              variant="solo"
              hide-details=""
              :style="{
                borderBottom: '3px solid #272727',
                borderLeft: '1px solid #272727',
                borderTop: '1px solid #272727',
                borderRight: '3px solid #272727',
              }"
              :loading="emailChecking"
              style="border-radius: 5px"
              v-model="email"
              @keyup.enter="checkEmailExists"
            >
              <template v-slot:append-inner>
                <v-btn
                  icon="mdi-send"
                  size="small"
                  variant="text"
                  @click="checkEmailExists"
                ></v-btn>
              </template>
            </v-text-field>

            <div
              v-if="email && mode === 'signup'"
              style="gap: 10px; display: flex"
            >
              <v-text-field
                placeholder="First name"
                flat
                variant="solo"
                hide-details=""
                ref="first_name"
                :style="{
                  borderBottom: '3px solid #272727',
                  borderLeft: '1px solid #272727',
                  borderTop: '1px solid #272727',
                  borderRight: '3px solid #272727',
                }"
                style="border-radius: 6px"
                v-model="first_name"
              ></v-text-field>
              <v-text-field
                placeholder="Last name"
                flat
                variant="solo"
                hide-details=""
                :style="{
                  borderBottom: '3px solid #272727',
                  borderLeft: '1px solid #272727',
                  borderTop: '1px solid #272727',
                  borderRight: '3px solid #272727',
                }"
                style="border-radius: 6px"
                v-model="last_name"
              ></v-text-field>
            </div>
            <v-text-field
              ref="password"
              v-if="email && (mode === 'signup' || mode === 'signin')"
              placeholder="Password"
              flat
              variant="solo"
              hide-details=""
              :style="{
                borderBottom: '3px solid #272727',
                borderLeft: '1px solid #272727',
                borderTop: '1px solid #272727',
                borderRight: '3px solid #272727',
              }"
              style="border-radius: 5px"
              v-model="password"
              @keyup.enter="mode === 'signup' ? signUp() : signIn()"
              type="password"
            ></v-text-field>
            <p
              style="text-align: end; cursor: pointer"
              v-if="email && mode === 'signin'"
              @click="resetPassword"
            >
              <u>Reset password</u>
            </p>
            <v-checkbox
              v-if="email && mode === 'signup'"
              class="animate__animated animate__slideInRight my-0 py-0"
              v-model="newsletter"
              label="Subscribe to newsletter"
            ></v-checkbox>
            <p v-if="error" class="text-error">
              Something went wrong verifying your invitation. Please try again.
              <u
                style="cursor: pointer"
                @click="
                  $router.push('/access');
                  error = false;
                "
                >Or sign up for a free trial outside {{ $route.query.name }}.</u
              >
            </p>
            <v-btn
              elevation="0"
              color="primary"
              v-if="email && (mode === 'signup' || mode === 'signin')"
              height="50"
              block
              :disabled="!email || !password"
              @click="mode === 'signup' ? signUp() : signIn()"
              ><span class="text-white"> Continue </span></v-btn
            >
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { db } from "@/firebase";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  getAdditionalUserInfo,
  signInWithEmailAndPassword,
} from "firebase/auth";
// import axios from "axios";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { mapState } from "vuex";
// import axios from "axios";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

export default {
  computed: {
    ...mapState({
      loading: (state) => state.loading,
      userProfile: (state) => state.users.userProfile,
    }),
  },
  async mounted() {
    if (this.$route.query.ref) {
      this.referral = this.$route.query.ref;
    }
    if (this.$route.query.mode) {
      this.mode = this.$route.query.mode;
    }
    if (this.$route.query.ws) {
      this.join_workspace = { uid: null, name: null };
      this.join_workspace.uid = this.$route.query.ws;
      this.join_workspace.name = this.$route.query.name;
    }
  },
  data() {
    return {
      email: "",
      first_name: "",
      last_name: "",
      join_workspace: null,
      mode: null,
      newsletter: false,
      overlay: false,
      password: "",
      referral: null,
      useEmail: false,
      emailChecking: false,
      error: false,
    };
  },
  methods: {
    async resetPassword() {
      console.log("Resetting password");
      console.log(this.email);
      let res;
      const sendPasswordResetEmail = httpsCallable(
        functions,
        "sendPasswordResetEmail",
      );
      res = await sendPasswordResetEmail({ email: this.email });
      console.log(res);
      this.$store.commit("setNotification", {
        show: true,
        text: "Password reset email sent",
        type: "info",
      });
    },
    async checkEmailExists() {
      this.emailChecking = true;
      if (!this.email) {
        this.$store.commit("setNotification", {
          show: true,
          text: "Please enter an email",
          type: "error",
        });
        return;
      }
      const checkEmailExists = httpsCallable(functions, "checkEmailExists");
      const res = await checkEmailExists({ email: this.email });
      console.log(res.data);
      if (res.data.exists) {
        if (res.data.providers.includes("google.com")) {
          this.$store.commit("setNotification", {
            show: true,
            text: "Please sign in with Google",
            type: "primary",
          });
          this.useEmail = false;
          this.mode = null;
        }
        if (res.data.needsVerification) {
          this.$store.commit("setNotification", {
            show: true,
            text: "Please verify your email",
            type: "primary",
          });
          this.useEmail = false;
          this.mode = null;
          this.$router.push("/verify");
        }
        this.mode = "signin";
        this.$nextTick(() => {
          if (this.$refs.password) {
            this.$refs.password.focus();
          }
        });
      } else {
        this.mode = "signup";
        this.$nextTick(() => {
          if (this.$refs.first_name) {
            this.$refs.first_name.focus();
          }
        });
      }
      this.emailChecking = false;
    },

    signIn() {
      const auth = getAuth();
      signInWithEmailAndPassword(auth, this.email, this.password)
        .then((userCredential) => {
          // Signed in
          const user = userCredential.user;
          console.log(user);
        })
        .catch((error) => {
          console.log(error.code);
          if (error.code.includes("invalid-email")) {
            this.$store.commit("setNotification", {
              show: true,
              text: `There is no account found with this email.`,
              type: "error",
            });
          } else if (error.code.includes("wrong-password")) {
            this.$store.commit("setNotification", {
              show: true,
              text: "Wrong password! Please try again.",
              type: "error",
            });
          } else {
            this.$store.commit("setNotification", {
              show: true,
              text: "Something went wrong. Please try again.",
              type: "error",
            });
          }
        });
    },

    async signUp() {
      this.$store.commit("setLoading", { type: "general", val: true });

      if (this.join_workspace?.uid) {
        let res;
        try {
          const verifyInvite = httpsCallable(functions, "verifyInvite");
          res = await verifyInvite({
            email: this.email,
            workspace: this.join_workspace.uid,
          });
          console.log(res.data);
        } catch (error) {
          console.log("Something went wrong verifying invite");
          this.$store.commit("setLoading", { type: "general", val: false });
          this.$store.commit("setNotification", {
            show: true,
            text: "Something went wrong verifying your invitation",
            type: "error",
          });
          this.error = true;
          return;
        }
        console.log(res.data);
        if (res.data.allowed) {
          this.join_workspace = res.data;
        } else {
          this.join_workspace = null;
        }
      }

      try {
        await this.$store.dispatch("signupWithEmail", {
          email: this.email,
          password: this.password,
          last_name: this.last_name,
          first_name: this.first_name,
          referral: this.referral,
          newsletter: this.newsletter,
          workspace: this.join_workspace?.workspace || null,
          workspaces: this.join_workspace?.workspace
            ? [this.join_workspace.workspace]
            : [],
        });

        this.$router.replace({
          name: "Verify",
          params: {
            email: this.email,
          },
        });
      } catch (error) {
        console.log(error);
        this.$router.push("/password?reason=Unauthorized");
      }

      this.$store.commit("setLoading", { type: "general", val: false });
    },
    async google() {
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      const vm = this;
      // Check brands for trial
      const brands = await getDoc(doc(db, "settings", "trial"));
      const trial_brands = brands.data().brands;

      let result;
      try {
        result = await signInWithPopup(auth, provider);
      } catch (error) {
        let message = error.message;
        // Extract custom message from blocking function error
        const jsonMatch = error.message?.match(/\{.*\}/);
        if (jsonMatch) {
          try {
            const parsed = JSON.parse(jsonMatch[0]);
            message = parsed.error?.message || message;
          } catch {
            // Keep original message if parsing fails
          }
        }
        console.log(message);
        this.$store.commit("setNotification", {
          show: true,
          text: message,
          type: "error",
        });
        return;
      }
      console.log(result);

      vm.$store.commit("setLoading", { type: "general", val: true });
      const user = result.user;
      const details = getAdditionalUserInfo(result);

      if (details.isNewUser) {
        console.log("Sign up: new user");
        let dataUri = null;

        if (this.join_workspace?.uid) {
          let res;
          try {
            const verifyInvite = httpsCallable(functions, "verifyInvite");
            res = await verifyInvite({
              email: user.email,
              workspace: this.join_workspace.uid,
            });
            console.log(res.data);
          } catch (error) {
            console.log("Something went wrong verifying invite");
            return;
          }
          console.log(res.data);
          if (res.data.allowed) {
            this.join_workspace = res.data;
          } else {
            this.join_workspace = null;
          }
        }
        // TODO, check if i can make this work.
        // if (process.env.NODE_ENV === "production") {
        //   const image = await axios.get(result.user.photoURL, {
        //     responseType: "arraybuffer",
        //   });
        //   const avatar = Buffer(image.data, "binary").toString("base64");
        //   var prefix = "data:" + image.headers["content-type"] + ";base64,";
        //   dataUri = prefix + avatar;
        // }
        const name = result.user.displayName;
        const nameArray = name.split(" ");
        let firstName = nameArray[0];
        nameArray.splice(0, 1);

        console.log("join workspace:");
        console.log(this.join_workspace);

        // Add a new document in collection "users"
        await setDoc(doc(db, "users", user.uid), {
          first_name: firstName,
          last_name: nameArray.join(" "),
          name: name,
          uid: user.uid,
          avatar: dataUri || null,
          email: user.email,
          created_at: Math.round(Date.now() / 1000),
          last_login: Math.round(Date.now() / 1000),

          notifications: [],
          subscription: {
            brands: trial_brands,
            mrr: null,
            plan: null,
            status: "active",
            trial: true,
            active: true,
            workspaces: [],
          },
          workspace: this.join_workspace?.workspace || null,
          workspaces: this.join_workspace?.workspace
            ? [this.join_workspace.workspace]
            : [],
          referrals: [],
          preferences: {
            feed: [],
            notifications: {
              newsletter: false,
              summary: true,
              ideas: true,
            },
            preview_size: "small",
          },
        });

        console.log("finished adding user");
        this.$store.dispatch("fetchUserProfile", user);
      }
    },
    openTab(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
@import "./styles.scss";
</style>
